import AdminSidebar from "./AdminSidebar.jsx";

const DashboardAdminLayout = ({ children }) => {
  return (
    <div className="flex h-dvh bg-gray-50">
      {/* Sidebar fijo */}
      {/* Reserves the 80px rail on tablets so the expanded sidebar overlays the content */}
      <div className="relative shrink-0 w-20 lg:w-auto">
        <AdminSidebar />
      </div>

      {/* Área de contenido principal */}
      <main className="flex-1 overflow-y-auto p-6">
        {children}
      </main>
    </div>
  );
};

export default DashboardAdminLayout;